module.exports = __webpack_public_path__ + "static/media/photo-1532452119098-a3650b3c46d3.69f63b76.jfif";